'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d3Voronoi = require('d3-voronoi');

var _Container = require('../Container');

var _Container2 = _interopRequireDefault(_Container);

var _SvgWrapper = require('../SvgWrapper');

var _SvgWrapper2 = _interopRequireDefault(_SvgWrapper);

var _enhance = require('./enhance');

var _enhance2 = _interopRequireDefault(_enhance);

var _props = require('./props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
var Voronoi = function Voronoi(_ref) {
    var data = _ref.data,
        margin = _ref.margin,
        width = _ref.width,
        height = _ref.height,
        outerWidth = _ref.outerWidth,
        outerHeight = _ref.outerHeight,
        enableSites = _ref.enableSites,
        enableLinks = _ref.enableLinks,
        enablePolygons = _ref.enablePolygons,
        theme = _ref.theme,
        borderWidth = _ref.borderWidth,
        borderColor = _ref.borderColor,
        linkWidth = _ref.linkWidth,
        linkColor = _ref.linkColor,
        siteSize = _ref.siteSize,
        siteColor = _ref.siteColor;

    var voronoi = (0, _d3Voronoi.voronoi)().x(function (d) {
        return d.x;
    }).y(function (d) {
        return d.y;
    }).extent([[0, 0], [width, height]]);

    var polygons = voronoi.polygons(data);
    var links = voronoi.links(data);

    return _react2.default.createElement(
        _Container2.default,
        { isInteractive: false, theme: theme },
        function (_ref2) {
            var showTooltip = _ref2.showTooltip,
                hideTooltip = _ref2.hideTooltip;
            return _react2.default.createElement(
                _SvgWrapper2.default,
                { width: outerWidth, height: outerHeight, margin: margin },
                enableLinks && links.map(function (l) {
                    return _react2.default.createElement('line', {
                        key: l.source.id + '.' + l.target.id,
                        fill: 'none',
                        stroke: linkColor,
                        strokeWidth: linkWidth,
                        x1: l.source.x,
                        y1: l.source.y,
                        x2: l.target.x,
                        y2: l.target.y
                    });
                }),
                enablePolygons && polygons.map(function (p) {
                    return _react2.default.createElement('path', {
                        key: p.data.id,
                        fill: 'none',
                        stroke: borderColor,
                        strokeWidth: borderWidth,
                        d: 'M' + p.join('L') + 'Z',
                        onClick: function onClick() {
                            console.log(p.data);
                        }
                    });
                }),
                enableSites && data.map(function (d) {
                    return _react2.default.createElement('circle', {
                        key: d.id,
                        r: siteSize / 2,
                        cx: d.x,
                        cy: d.y,
                        fill: siteColor,
                        stroke: 'none'
                    });
                })
            );
        }
    );
};

Voronoi.propTypes = _props.VoronoiPropTypes;

exports.default = (0, _enhance2.default)(Voronoi);


//////////////////
// WEBPACK FOOTER
// ./~/nivo/lib/components/charts/voronoi/Voronoi.js
// module id = 525
// module chunks = 0